import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=35c4f89a&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35c4f89a')) {
      api.createRecord('35c4f89a', component.options)
    } else {
      api.reload('35c4f89a', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=35c4f89a&", function () {
      api.rerender('35c4f89a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2pT7KU8qxtdVr/JS/comp/openstreetmap.vue"
export default component.exports